import { registerPicker } from 'oderon-vue/cpts/generic-report/ReportPicker.vue'

import HistoryTypePicker from '../views/clients/home/history/HistoryTypePicker.vue'
import RDEventTypePicker from '../views/vehicle/events/RDEventTypePicker.vue'
import MailboxInfoPicker from '../views/clients/home/mailbox/MailboxInfoPicker.vue'
import OccurConfigPicker from '../components/pickers/OccurConfigPicker.vue'
import VehiclePicker from '../components/pickers/VehiclePicker'
import VehicleTagPicker from '../components/pickers/VehicleTagPicker.vue'
import OrgPicker from '../components/pickers/OrgPicker'
import FWPicker from '../components/pickers/FWPicker'
import OperatorPicker from '../components/pickers/OperatorPicker'
import DepotPicker from '../components/pickers/DepotPicker'
import TechnicianPicker from '../components/pickers/TechnicianPicker'
import BrandModelPicker from '../components/pickers/BrandModelPicker'
import PapermanSubjectPicker from '../views/tools/paperman/PapermanSubjectPicker.vue'
import PapermanActionPicker from '../views/tools/paperman/PapermanActionPicker.vue'
import CostCenterPicker from '../views/cost-centers/measure-v2/CostCenterPicker.vue'
import CostCenterPeriodPicker from '../views/cost-centers/measure-v2/CostCenterPeriodPicker.vue'
import CostCenterFormatPicker from '../views/cost-centers/measure-v2/CostCenterFormatPicker.vue'
import MultiproductPeriodPicker from '../views/multiproduct-measure/MultiproductPeriodPicker.vue'
import MultiproductFormatPicker from '../views/multiproduct-measure/MultiproductFormatPicker.vue'
import LostStatusPicker from '../components/pickers/LostStatusPicker'

registerPicker('HistoryType', HistoryTypePicker)
registerPicker('RDEventType', RDEventTypePicker)
registerPicker('MailboxInfo', MailboxInfoPicker)
registerPicker('OccurConfig', OccurConfigPicker)
registerPicker('Vehicle', VehiclePicker)
registerPicker('VehicleTag', VehicleTagPicker)
registerPicker('Org', OrgPicker)
registerPicker('Firmware', FWPicker)
registerPicker('Operator', OperatorPicker)
registerPicker('Depot', DepotPicker)
registerPicker('Technician', TechnicianPicker)
registerPicker('BrandModel', BrandModelPicker)
registerPicker('PapermanSubject', PapermanSubjectPicker)
registerPicker('PapermanAction', PapermanActionPicker)
registerPicker('CostCenter', CostCenterPicker)
registerPicker('CostCenterPeriod', CostCenterPeriodPicker)
registerPicker('CostCenterFormat', CostCenterFormatPicker)
registerPicker('MultiproductPeriod', MultiproductPeriodPicker)
registerPicker('MultiproductFormat', MultiproductFormatPicker)
registerPicker('LostStatus', LostStatusPicker)
